import { render, staticRenderFns } from "./orangeIdcard.vue?vue&type=template&id=7ec46815"
import script from "./orangeIdcard.vue?vue&type=script&lang=js"
export * from "./orangeIdcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports